module.exports = __webpack_public_path__ + "static/img/13.a88291f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/13.jpg
// module id = bRk+
// module chunks = 1